import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PurchaseService } from '@services/purchasecallback.service';

@Component({
  selector: 'app-purchase-callback',
  templateUrl: './purchase-callback.component.html',
  styleUrls: ['./purchase-callback.component.scss']
})
export class PurchaseCallbackComponent implements OnInit {

  title = 'Processing Purchase...';
  message = 'Please wait while we process your purchase.';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private purchaseService: PurchaseService
  ) { }

  ngOnInit(): void {


    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        // Calling the service method instead of http.get directly
        this.purchaseService.verifyPurchase(token).subscribe({
          next: () => {
            this.title = 'Purchase Successful';
            this.message = 'Your subscription is successfully active, Our support team will proceed and contact you.';
          },
          error: (err) => {
            this.title = 'Purchase Failed';
            this.message = (err?.error || 'Something went wrong while processing purchase.') + ' Please try again.';
          }
        });
      } else {
        this.title = 'Purchase Failed';
        this.message = 'Token not found.';
      }
    });

  }
}